<template>
  <ContractTemplateEditor turnalFlag="edit" />
</template>

<script>
import ContractTemplateEditor from './components/contractTemplateEditor.vue'
import { storageKeyEdit, storageTitleKeyEdit } from './config'
import { clearLocalStorage } from '@/utils/cache'

export default {
  name: 'editContractTemp',
  components: {
    ContractTemplateEditor,
  },
  data() {
    return {
      storageKeyEdit,
      storageTitleKeyEdit,
    }
  },
  methods: {
    clearCache() {
      clearLocalStorage(this.storageKeyEdit)
      clearLocalStorage(this.storageTitleKeyEdit)
    },
  },
  created() {
    this.$EventBus.$on('autoRemoveCache', this.clearCache)
  },
  beforeDestroy() {
    this.$EventBus.$off('autoRemoveCache', this.clearCache)
  },
}
</script>

